/* eslint-disable import/prefer-default-export */
import QueryParam, { getParameterByName } from './QueryParam.class'

export * from './enum'
export {
  QueryParam,
  getParameterByName,
}
